// extracted by mini-css-extract-plugin
module.exports = {"loading-overlay":"Loader_loading-overlay__1zGTd","css-loader":"Loader_css-loader__2vb49","spinner":"Loader_spinner__1BGHY"};